/* eslint-disable @next/next/no-img-element */
import Button from "components/general/buttonv2";
import { useUser } from "hooks/useUser";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { tokenStore } from "src/hooks/useToken";
import { http } from "src/http";
import styled from "styled-components";
import { getRewardfulReferralData } from "src/lib/rewardful";

const SvgOne = () => (
  <svg width="47" height="48" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="#F1F0F0" />
    <rect y="26.9922" width="20.7839" height="20.7839" rx="2.36181" fill="#604AFF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.6132 26.9922C33.9692 26.9922 32.6365 28.3249 32.6365 29.9689V34.4079L28.1984 34.4079C26.5544 34.4079 25.2217 35.7406 25.2217 37.3846C25.2217 39.0286 26.5544 40.3613 28.1984 40.3613H32.6365V44.7994C32.6365 46.4434 33.9692 47.7761 35.6132 47.7761C37.2572 47.7761 38.5899 46.4434 38.5899 44.7994V40.3613H43.0289C44.6729 40.3613 46.0056 39.0286 46.0056 37.3846C46.0056 35.7406 44.6729 34.4079 43.0289 34.4079L38.5899 34.4079V29.9689C38.5899 28.3249 37.2572 26.9922 35.6132 26.9922Z"
      fill="#F1F0F0"
    />
    <rect x="25.2227" y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="#604AFF" />
  </svg>
);
const SvgTwo = () => (
  <svg width="70" height="69" viewBox="0 0 70 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="35.2412"
      cy="34.4685"
      r="26.2772"
      transform="rotate(-67.7966 35.2412 34.4685)"
      fill="#604AFF"
    />
    <path
      d="M53.8586 23.6084C56.2518 27.7118 57.2224 32.4909 56.6195 37.2027C56.0166 41.9146 53.874 46.2953 50.5247 49.6639C47.1753 53.0324 42.807 55.2002 38.0987 55.8301C33.3903 56.46 28.6058 55.5168 24.4888 53.1472C20.3718 50.7775 17.1529 47.1141 15.3326 42.7264C13.5123 38.3387 13.1925 33.4726 14.4229 28.8844C15.6533 24.2963 18.3651 20.2431 22.1365 17.355"
      stroke="#DEDEDE"
      strokeWidth="2.72012"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.5411 24.9747C35.5411 24.2831 35.2664 23.6199 34.7774 23.1309C34.2884 22.6419 33.6252 22.3672 32.9336 22.3672C32.2421 22.3672 31.5789 22.6419 31.0899 23.1309C30.6009 23.6199 30.3262 24.2831 30.3262 24.9747V35.4046C30.3263 36.0961 30.6011 36.7592 31.0902 37.2481L38.4641 44.6246C38.7064 44.8669 38.994 45.059 39.3105 45.1902C39.627 45.3213 39.9663 45.3888 40.3089 45.3888C40.6515 45.3888 40.9908 45.3213 41.3073 45.1902C41.6238 45.059 41.9114 44.8669 42.1537 44.6246C42.396 44.3824 42.5881 44.0947 42.7192 43.7782C42.8503 43.4617 42.9178 43.1224 42.9178 42.7798C42.9178 42.4372 42.8503 42.098 42.7192 41.7814C42.5881 41.4649 42.396 41.1773 42.1537 40.935L35.5411 34.3251V24.9747Z"
      fill="#DEDEDE"
    />
    <circle cx="40.1976" cy="13.5052" r="1.181" fill="#DEDEDE" />
    <circle cx="31.8275" cy="12.9134" r="1.181" fill="#DEDEDE" />
    <circle cx="47.0501" cy="16.308" r="1.181" fill="#DEDEDE" />
  </svg>
);
const SvgThree = () => (
  <svg width="53" height="41" viewBox="0 0 53 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.1594 0.363282C31.7378 0.363282 33.2516 0.999663 34.3677 2.13243C35.4838 3.26519 36.1108 4.80155 36.1108 6.40352L6.35376 6.40352L6.35376 30.5645C4.77534 30.5645 3.26158 29.9281 2.14547 28.7953C1.02937 27.6626 0.402344 26.1262 0.402344 24.5242L0.402345 6.40352C0.402345 4.80155 1.02937 3.26519 2.14547 2.13243C3.26158 0.999661 4.77534 0.363281 6.35376 0.363281L30.1594 0.363282Z"
      fill="#DEDEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5488 10.7363C13.589 10.7363 12.6684 11.1176 11.9897 11.7964C11.311 12.4751 10.9297 13.3956 10.9297 14.3555V37.2124C10.9297 38.1722 11.311 39.0928 11.9897 39.7715C12.6684 40.4502 13.589 40.8315 14.5488 40.8315H48.7437C49.7035 40.8315 50.6241 40.4502 51.3028 39.7715C51.9815 39.0928 52.3628 38.1722 52.3628 37.2124V14.3555C52.3628 13.3956 51.9815 12.4751 51.3028 11.7964C50.6241 11.1176 49.7035 10.7363 48.7437 10.7363H14.5488ZM48.7437 37.2124H14.5488L25.9131 17.9746L35.9518 33.5932L42.0669 21.5938L48.7437 37.2124Z"
      fill="#604AFF"
    />
  </svg>
);
const SvgFour = () => (
  <svg width="58" height="57" viewBox="0 0 58 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.1696 42.7507C36.2228 41.5455 36.9069 40.4607 37.8605 39.7057C40.1742 37.881 41.8619 35.3808 42.6891 32.5527C43.5163 29.7246 43.4419 26.709 42.4763 23.9251C41.5106 21.1412 39.7016 18.7273 37.3008 17.0189C34.8999 15.3106 32.0265 14.3926 29.0799 14.3926C26.1332 14.3926 23.2598 15.3106 20.859 17.0189C18.4581 18.7273 16.6492 21.1412 15.6835 23.9251C14.7178 26.709 14.6434 29.7246 15.4706 32.5527C16.2978 35.3808 17.9856 37.881 20.2992 39.7057C21.2563 40.4607 21.937 41.5455 21.9866 42.7507H36.1731H36.1696Z"
      fill="#604AFF"
    />
    <path
      d="M32.6226 3.75581C32.6226 2.81565 32.2491 1.914 31.5843 1.24921C30.9195 0.584413 30.0179 0.210938 29.0777 0.210938C28.1375 0.210938 27.2359 0.584413 26.5711 1.24921C25.9063 1.914 25.5328 2.81565 25.5328 3.75581V7.30067C25.5328 8.24083 25.9063 9.14248 26.5711 9.80727C27.2359 10.4721 28.1375 10.8455 29.0777 10.8455C30.0179 10.8455 30.9195 10.4721 31.5843 9.80727C32.2491 9.14248 32.6226 8.24083 32.6226 7.30067V3.75581ZM49.131 13.529C49.7767 12.8604 50.134 11.965 50.126 11.0355C50.1179 10.1061 49.7451 9.21699 49.0878 8.55975C48.4306 7.9025 47.5415 7.52969 46.612 7.52161C45.6826 7.51354 44.7871 7.87084 44.1186 8.51656L41.6124 11.0228C40.9666 11.6914 40.6093 12.5868 40.6174 13.5163C40.6255 14.4457 40.9983 15.3348 41.6555 15.9921C42.3128 16.6493 43.2019 17.0221 44.1313 17.0302C45.0608 17.0383 45.9562 16.681 46.6248 16.0352L49.131 13.529ZM57.4366 28.5699C57.4366 29.51 57.0632 30.4117 56.3984 31.0765C55.7336 31.7413 54.8319 32.1148 53.8918 32.1148H50.3469C49.4067 32.1148 48.5051 31.7413 47.8403 31.0765C47.1755 30.4117 46.802 29.51 46.802 28.5699C46.802 27.6297 47.1755 26.7281 47.8403 26.0633C48.5051 25.3985 49.4067 25.025 50.3469 25.025H53.8918C54.8319 25.025 55.7336 25.3985 56.3984 26.0633C57.0632 26.7281 57.4366 27.6297 57.4366 28.5699ZM11.5306 16.0352C11.8576 16.3738 12.2488 16.6439 12.6812 16.8296C13.1137 17.0154 13.5789 17.1132 14.0496 17.1173C14.5203 17.1214 14.9871 17.0317 15.4227 16.8535C15.8584 16.6752 16.2541 16.412 16.587 16.0792C16.9198 15.7463 17.183 15.3505 17.3613 14.9149C17.5395 14.4792 17.6292 14.0125 17.6251 13.5418C17.621 13.0711 17.5232 12.6059 17.3375 12.1734C17.1517 11.7409 16.8816 11.3498 16.543 11.0228L14.0368 8.51656C13.3683 7.87084 12.4728 7.51354 11.5434 7.52161C10.6139 7.52969 9.7248 7.9025 9.06756 8.55975C8.41031 9.21699 8.0375 10.1061 8.02942 11.0355C8.02135 11.965 8.37865 12.8604 9.02438 13.529L11.5306 16.0352ZM11.3534 28.5699C11.3534 29.51 10.9799 30.4117 10.3151 31.0765C9.6503 31.7413 8.74864 32.1148 7.80849 32.1148H4.26362C3.32346 32.1148 2.42181 31.7413 1.75702 31.0765C1.09223 30.4117 0.71875 29.51 0.71875 28.5699C0.71875 27.6297 1.09223 26.7281 1.75702 26.0633C2.42181 25.3985 3.32346 25.025 4.26362 25.025H7.80849C8.74864 25.025 9.6503 25.3985 10.3151 26.0633C10.9799 26.7281 11.3534 27.6297 11.3534 28.5699Z"
      fill="#DEDEDE"
    />
    <path
      d="M21.9893 49.8378V46.293H36.1687V49.8378C36.1687 51.7182 35.4218 53.5215 34.0922 54.851C32.7626 56.1806 30.9593 56.9276 29.079 56.9276C27.1987 56.9276 25.3954 56.1806 24.0658 54.851C22.7362 53.5215 21.9893 51.7182 21.9893 49.8378Z"
      fill="#DEDEDE"
    />
  </svg>
);

const SvgPremiumOne = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.04993 0.757812C3.8347 0.757813 3.62828 0.843312 3.47609 0.995502C3.3239 1.14769 3.2384 1.35411 3.2384 1.56934V2.38086H2.42688C1.99642 2.38086 1.58359 2.55186 1.27921 2.85624C0.974832 3.16062 0.803833 3.57345 0.803833 4.00391V12.1191C0.803833 12.5496 0.974832 12.9624 1.27921 13.2668C1.58359 13.5712 1.99642 13.7422 2.42688 13.7422H12.1652C12.5956 13.7422 13.0084 13.5712 13.3128 13.2668C13.6172 12.9624 13.7882 12.5496 13.7882 12.1191V4.00391C13.7882 3.57345 13.6172 3.16062 13.3128 2.85624C13.0084 2.55186 12.5956 2.38086 12.1652 2.38086H11.3536V1.56934C11.3536 1.35411 11.2681 1.14769 11.1159 0.995502C10.9638 0.843312 10.7573 0.757813 10.5421 0.757812C10.3269 0.757813 10.1205 0.843312 9.96828 0.995502C9.81609 1.14769 9.73059 1.35411 9.73059 1.56934V2.38086H4.86145V1.56934C4.86145 1.35411 4.77595 1.14769 4.62376 0.995502C4.47157 0.843312 4.26516 0.757813 4.04993 0.757812ZM4.04993 4.81543C3.8347 4.81543 3.62828 4.90093 3.47609 5.05312C3.3239 5.20531 3.2384 5.41172 3.2384 5.62695C3.2384 5.84218 3.3239 6.0486 3.47609 6.20079C3.62828 6.35298 3.8347 6.43848 4.04993 6.43848H10.5421C10.7573 6.43848 10.9638 6.35298 11.1159 6.20079C11.2681 6.0486 11.3536 5.84218 11.3536 5.62695C11.3536 5.41172 11.2681 5.20531 11.1159 5.05312C10.9638 4.90093 10.7573 4.81543 10.5421 4.81543H4.04993Z"
      fill="#DEDEDE"
    />
  </svg>
);
const SvgPremiumTwo = () => (
  <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.76939 6.43638C7.5939 6.43638 8.38464 6.10885 8.96766 5.52583C9.55067 4.94282 9.87821 4.15208 9.87821 3.32757C9.87821 2.50306 9.55067 1.71232 8.96766 1.1293C8.38464 0.546285 7.5939 0.21875 6.76939 0.21875C5.94488 0.21875 5.15414 0.546285 4.57113 1.1293C3.98811 1.71232 3.66057 2.50306 3.66057 3.32757C3.66057 4.15208 3.98811 4.94282 4.57113 5.52583C5.15414 6.10885 5.94488 6.43638 6.76939 6.43638ZM6.76939 8.50893C8.41841 8.50893 9.99989 9.164 11.1659 10.33C12.332 11.4961 12.987 13.0775 12.987 14.7266H0.551758C0.551758 13.0775 1.20683 11.4961 2.37286 10.33C3.53889 9.164 5.12037 8.50893 6.76939 8.50893Z"
      fill="#DEDEDE"
    />
  </svg>
);
const SvgPremiumThree = () => (
  <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00171 4.03497C5.18918 4.2225 5.29449 4.47681 5.29449 4.74197C5.29449 5.00714 5.18918 5.26145 5.00171 5.44897L2.70871 7.74197L5.00171 10.035C5.09722 10.1272 5.1734 10.2376 5.22581 10.3596C5.27822 10.4816 5.3058 10.6128 5.30696 10.7456C5.30811 10.8784 5.28281 11.01 5.23253 11.1329C5.18225 11.2558 5.108 11.3675 5.0141 11.4614C4.92021 11.5553 4.80856 11.6295 4.68566 11.6798C4.56277 11.7301 4.43109 11.7554 4.29831 11.7542C4.16553 11.7531 4.03431 11.7255 3.9123 11.6731C3.7903 11.6207 3.67996 11.5445 3.58771 11.449L0.587708 8.44897C0.400237 8.26145 0.294922 8.00714 0.294922 7.74197C0.294922 7.47681 0.400237 7.2225 0.587708 7.03497L3.58771 4.03497C3.77524 3.8475 4.02954 3.74219 4.29471 3.74219C4.55987 3.74219 4.81418 3.8475 5.00171 4.03497ZM13.5877 4.03497C13.7752 3.8475 14.0295 3.74219 14.2947 3.74219C14.5599 3.74219 14.8142 3.8475 15.0017 4.03497L18.0017 7.03497C18.1892 7.2225 18.2945 7.47681 18.2945 7.74197C18.2945 8.00714 18.1892 8.26145 18.0017 8.44897L15.0017 11.449C14.9095 11.5445 14.7991 11.6207 14.6771 11.6731C14.5551 11.7255 14.4239 11.7531 14.2911 11.7542C14.1583 11.7554 14.0267 11.7301 13.9038 11.6798C13.7809 11.6295 13.6692 11.5553 13.5753 11.4614C13.4814 11.3675 13.4072 11.2558 13.3569 11.1329C13.3066 11.01 13.2813 10.8784 13.2825 10.7456C13.2836 10.6128 13.3112 10.4816 13.3636 10.3596C13.416 10.2376 13.4922 10.1272 13.5877 10.035L15.8807 7.74197L13.5877 5.44897C13.4002 5.26145 13.2949 5.00714 13.2949 4.74197C13.2949 4.47681 13.4002 4.2225 13.5877 4.03497Z"
      fill="#DEDEDE"
    />
    <path
      d="M11.9503 0.986596C11.851 0.900571 11.7358 0.834949 11.6112 0.793477C11.4865 0.751948 11.3549 0.735379 11.2239 0.744718C11.0929 0.754056 10.965 0.789119 10.8475 0.847902C10.73 0.906685 10.6253 0.988037 10.5393 1.08731C10.4532 1.18658 10.3876 1.30183 10.3462 1.42648L6.34615 13.4265C6.26234 13.6782 6.28195 13.9528 6.40066 14.1901C6.51937 14.4273 6.72746 14.6077 6.97915 14.6915C7.23084 14.7753 7.50552 14.7557 7.74275 14.637C7.97998 14.5183 8.16034 14.3102 8.24415 14.0585L12.2442 2.05848C12.2857 1.93385 12.3022 1.80227 12.2929 1.67124C12.2836 1.54021 12.2485 1.41231 12.1897 1.29484C12.1309 1.17736 12.0496 1.07262 11.9503 0.986596Z"
      fill="#604AFF"
    />
  </svg>
);
const StyledRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  svg {
    margin-right: 1rem;
    width: 24px;
    height: auto;
    flex: 0 0 24px;
  }
`;
export const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 2rem;
  font-family: "Open Sans", sans-serif;
  @media screen and (max-width: 920px) {
    margin-top: 3rem;
  }
`;
export const StyledContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  border-radius: 1rem;
  background-color: var(--raised-background-color-three);
  min-height: 720px;
  @media screen and (max-width: 920px) {
    flex-direction: column;
  }
`;
const StyledLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 2rem 2rem 2rem;
  box-sizing: border-box;
  @media screen and (max-width: 920px) {
    padding: 2rem;
  }
`;
const StyledRight = styled.div`
  flex: 2;
  background-color: var(--raised-background-color-two);
  display: flex;
  flex-direction: column;
  padding: 2rem 2rem 2rem 3rem;
  text-align: left;
  justify-content: center;
`;
export const StyledInput = styled.input`
  background: var(--raised-background-color-two);
  border: 1px solid var(--border-color);
  box-sizing: border-box;
  border-radius: 5px;
  height: 41px;
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  color: var(--text-color);
  font-size: 1rem;
`;

export const StyledSubText = styled.div`
  font-size: 12px;
  margin-bottom: 1rem;
  span {
    color: #5885f8;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;
export const StyledForm = styled.form`
  margin-top: 2rem;
  display: flex;
  max-width: 420px;
  flex-direction: column;
  label {
    display: flex;
    flex-direction: column;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 700;
    input {
      margin-top: 0;
      margin-bottom: 0.5rem;
    }
  }
`;
export const StyledError = styled.div`
  color: red;
  font-size: 12px;
`;
export const StyledFieldError = styled.span`
  color: red;
  font-size: 12px;
  margin-top: -5px;
`;

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
`;
const StyledSuccessMessage = styled.div`
  padding: 1rem;
  display: flex;
  background: rgb(12, 19, 13);
  gap: 1rem;
  margin-bottom: 2rem;
`;

const EMAIL_FORMAT_ERROR = "Entered value does not match email format";

const Login = () => {
  const router = useRouter();
  const { refreshUser, userState } = useUser();

  const [loadingState, setLoadingState] = useState(false);
  const [awaitingEmail, setAwaitingEmail] = useState(false);
  const [sentAdditionalLoginLink, setSentAdditionalLoginLink] = useState(false);

  const { getValues, register, handleSubmit } = useForm();

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);
  console.log(http);

  const onSubmit = handleSubmit(async (data) => {
    setLoadingState(true);
    const res = await http.request({
      method: "post",
      url: "/api/user/login/with-email",
      data: {
        email: data.email,
        referralData: getRewardfulReferralData(),
      },
    });
    if (res?.data?.data?.securityToken) {
      tokenStore.securityToken = res.data.data.securityToken;
    }
    if (awaitingEmail) {
      setSentAdditionalLoginLink(true);
    }
    setLoadingState(false);
    setAwaitingEmail(true);
  });

  useEffect(() => {
    if (!userState.retrieved) {
      return;
    }
    if (userState.user) {
      router.push("/account");
    }
  }, [router, userState.retrieved, userState.user]);

  if (awaitingEmail) {
    return (
      <StyledWrapper>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <img
            src="/images/media-kit/logos/redact-white.png"
            alt="Redact logo"
            style={{ height: "6rem", width: "auto", marginBottom: "4rem", alignSelf: "center" }}
          />
          <h1 style={{ fontSize: "2rem", fontWeight: 700 }}>Login link sent</h1>
          <StyledForm
            onSubmit={onSubmit}
            style={{ display: "flex", width: "100%", flexDirection: "column" }}
          >
            <p style={{ marginBottom: "2rem" }}>
              We have sent a login link to {getValues("email")}
            </p>

            {sentAdditionalLoginLink && (
              <StyledSuccessMessage>
                <svg
                  height="24"
                  width="24"
                  fill="rgb(102, 187, 106)"
                  clipRule="evenodd"
                  fillRule="evenodd"
                  strokeLinejoin="round"
                  strokeMiterlimit="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m11.998 2.005c5.517 0 9.997 4.48 9.997 9.997 0 5.518-4.48 9.998-9.997 9.998-5.518 0-9.998-4.48-9.998-9.998 0-5.517 4.48-9.997 9.998-9.997zm0 1.5c-4.69 0-8.498 3.807-8.498 8.497s3.808 8.498 8.498 8.498 8.497-3.808 8.497-8.498-3.807-8.497-8.497-8.497zm-5.049 8.886 3.851 3.43c.142.128.321.19.499.19.202 0 .405-.081.552-.242l5.953-6.509c.131-.143.196-.323.196-.502 0-.41-.331-.747-.748-.747-.204 0-.405.082-.554.243l-5.453 5.962-3.298-2.938c-.144-.127-.321-.19-.499-.19-.415 0-.748.335-.748.746 0 .205.084.409.249.557z"
                    fillRule="nonzero"
                  />
                </svg>
                <div style={{ textAlign: "left" }}>
                  <b>Success</b>
                  <div>Sent an additional login link!</div>
                </div>
              </StyledSuccessMessage>
            )}

            <StyledButton
              type={loadingState ? "button" : "submit"}
              buttonPrimary={true}
              alignSelf="flex-start"
              wrapperStyle={{ width: "100%" }}
              data-action-name="Register: Send Another Link"
            >
              {loadingState ? "Sending login link..." : "Send another link"}
            </StyledButton>

            <StyledButton
              alignSelf="flex-start"
              data-action-name="Register: Change Email"
              wrapperStyle={{ width: "100%" }}
              onClick={() => {
                setAwaitingEmail(false);
                setSentAdditionalLoginLink(false);
              }}
            >
              Change email
            </StyledButton>
          </StyledForm>
        </div>
      </StyledWrapper>
    );
  }
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledLeft>
          <h2>Premium</h2>
          <StyledRow>
            <SvgPremiumOne />
            Delete content from all time
          </StyledRow>
          <StyledRow>
            <SvgOne />
            Mass delete from 40+ websites and apps.
          </StyledRow>
          <StyledRow>
            <SvgTwo />
            Mass delete messages, posts, direct messages, files, images, and more.
          </StyledRow>
          <StyledRow>
            <SvgThree />
            Schedule automatic bulk deletions.
          </StyledRow>
          <StyledRow>
            <SvgFour />
            Smart delete by keyword, content type, and more!
          </StyledRow>
          <StyledRow>
            <SvgPremiumTwo />
            Enhanced support
          </StyledRow>
          <StyledRow>
            <SvgPremiumThree />
            Beta access to new features
          </StyledRow>
        </StyledLeft>
        <StyledRight>
          <img
            src="/images/media-kit/logos/redact-white.png"
            alt="Redact logo"
            style={{ height: "6rem", width: "auto", marginBottom: "1rem", alignSelf: "flex-start" }}
          />
          <h1>Sign up</h1>
          <StyledForm
            onSubmit={onSubmit}
            style={{ display: "flex", width: "100%", flexDirection: "column" }}
          >
            <label>
              email
              <StyledInput
                key="email"
                {...register("email", {
                  required: true,
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: EMAIL_FORMAT_ERROR,
                  },
                })}
              />
            </label>
            <Link href="/login" data-action-name="Register: Log In Redirect">
              Already have an account? Log in
            </Link>
            <StyledButton
              type={loadingState ? "button" : "submit"}
              buttonPrimary={true}
              alignSelf="flex-start"
              wrapperStyle={{ width: "100%", marginTop: "2rem" }}
              data-action-name="Register: Sign Up"
            >
              {loadingState ? "Sending login link..." : "Sign up"}
            </StyledButton>
          </StyledForm>
        </StyledRight>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Login;
